import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';
import { WarrenSession } from '@/modules/common/services/session';
import { FilterOption } from '@warrenbrasil/nebraska-web';
import {
  PerformanceTypeFilter,
  Portfolio
} from '@/modules/wealth/services/portfolio';
import { AnnualProfit } from './components/AnnualProfit';
import { RentabilityChart } from './components/RentabilityChart';
import { ProvisionedProfits } from './components/ProvisionedProfits';
import { ProfitChart } from './components/ProfitChart';

interface Props {
  portfolioId: string;
  portfolioDetails: Portfolio;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Performance',
  props: {
    portfolioId: null,
    portfolioDetails: null
  },
  setup(__props: any) {

const filters = [
  {
    label: 'Rentabilidade',
    active: true,
    key: 'profitability'
  },
  {
    label: 'Proventos',
    active: false,
    key: 'income'
  }
];



const isLoading = ref(false);
const hasError = ref(false);
const typeFilters = ref<PerformanceTypeFilter[]>(filters);

const isProfitSectionActive = computed(() => typeFilters.value[1].active);
const isEarningsSectionActive = computed(() => typeFilters.value[0].active);

const onSelectFilter = (filter: PerformanceTypeFilter) => {
  WarrenSession.set('warren.indexPortfolio.filterOption', filter.key);
  typeFilters.value = typeFilters.value.map(type => {
    if (filter.key === type.key) {
      return {
        ...filter,
        active: true
      };
    }
    return {
      ...type,
      active: false
    };
  });
};

onBeforeMount(() => {
  if (WarrenSession.get('warren.indexPortfolio.filterOption') === 'income') {
    const filter = filters.find(filter => filter.key === 'income');
    onSelectFilter(filter!);
  }
});

return { __sfc: true,filters, isLoading, hasError, typeFilters, isProfitSectionActive, isEarningsSectionActive, onSelectFilter, FilterOption, AnnualProfit, RentabilityChart, ProvisionedProfits, ProfitChart }
}

})